import { SignInMutationVariables } from '@/__generated__/graphql';
import { useMutation } from '@apollo/client';
import { Button, Container, Paper, PasswordInput, Text, TextInput, Title } from '@mantine/core';
import { isEmail, isNotEmpty, useForm } from '@mantine/form';
import useSignIn from 'react-auth-kit/hooks/useSignIn';
import { useNavigate } from 'react-router-dom';
import { signInDocument } from '../graphql/mutations';

export function SignIn() {
  const signIn = useSignIn();
  const navigate = useNavigate();

  const form = useForm<SignInMutationVariables['data']>({
    initialValues: {
      email: '',
      password: '',
    },
    validate: {
      email: isEmail('Invalid email'),
      password: isNotEmpty('No password entered'),
    },
  });

  const [mutate, { loading }] = useMutation(signInDocument, {
    onCompleted: ({ signIn: { token, user } }) => {
      localStorage.setItem('token', token);
      signIn({ auth: { token, type: 'Bearer' }, userState: user });
      void navigate('/');
    },
  });

  return (
    <Container size={420} my={40}>
      <Title ta="center">Lásky Krásky</Title>
      <Text c="dimmed" size="sm" ta="center" mt={5}>
        Pre vstup do administračného rozhrania je potrebné sa prihlásiť.
      </Text>

      <Paper withBorder shadow="md" p={30} mt={30} radius="md">
        <form onSubmit={form.onSubmit((data) => void mutate({ variables: { data } }))}>
          <TextInput
            label="Email"
            placeholder="zamestnanec1@laskykrasky.sk"
            withAsterisk
            {...form.getInputProps('email')}
          />
          <PasswordInput
            label="Heslo"
            placeholder="******"
            mt="md"
            withAsterisk
            {...form.getInputProps('password')}
          />
          <Button fullWidth mt="xl" type="submit" loading={loading}>
            Prihlásiť sa
          </Button>
        </form>
      </Paper>
    </Container>
  );
}
